<template>
  <v-dialog
    v-model="dialog"
    max-width="640px"
    @click:outside="hanleClickOutside"
  >
    <v-card height="400" class="overflow-y-hidden">
      <youtube
        video-id="V_g_Wb4-mIQ"
        player-height="400"
        @ready="ready"
      ></youtube>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: { type: Boolean, default: false },
  },
  created() {
    this.dialog = this.show;
  },
  watch: {
    show: function (newValue) {
      this.dialog = newValue;
    },
  },
  data() {
    return {
      dialog: false,
      player: null,
    };
  },
  methods: {
    hanleClickOutside() {
      this.dialog = false;
      this.$emit("close");
      this.player.stopVideo();
    },
    ready(event) {
      this.player = event.target;
    },
  },
};
</script>

<style>
</style>